var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRaiseissue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.885,
    height: 14.913,
    viewBox: "0 0 9.885 14.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5775",
    "data-name": "Group 5775",
    transform: "translate(2503.761 2287.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4709",
    "data-name": "Path 4709",
    d: "M204.712,45.537c-2.926,0-4.442,1.246-4.442,3.452v1.366h2.851v-1.5c0-.991.555-1.351,1.5-1.351s1.516.36,1.516,1.351c0,3.422-3.287,3.692-3.287,6.709a1.791,1.791,0,0,0,.165.84H205.7a2.258,2.258,0,0,1-.12-.766c0-2.521,3.572-3.062,3.572-6.649,0-2.206-1.516-3.452-4.442-3.452Z",
    transform: "translate(-2703.531 -2332.047)",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4710",
    "data-name": "Path 4710",
    d: "M288.28,444.15h2.9v2.086h-2.9Z",
    transform: "translate(-2788.93 -2718.833)",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiseissue);
export default __webpack_public_path__ + "static/media/raiseissue.5fd408de61741f004f136225c154078c.svg";
export { ForwardRef as ReactComponent };